<template>
  <div class="questionnaire">
    <div v-if="questionnaire.length" class="container" :class="kidSex==1?'boy': 'girl'">
      <div class="main">
        <div class="top" :class="kidSex==1?'boy': 'girl'">
          <div class="num">
            <span class="current-num" :class="kidSex==1?'boy': 'girl'">{{currentIndex+1}}</span>
            / {{questionnaire.length}}
          </div>
          <div class="title">{{currentQuestion.title}}<span class="sub-title">{{currentQuestion.multiSelect}}</span></div>
        </div>
        <div @click="selectQuestion">
          <cube-checker v-if="currentQuestion.type==0" v-model="currentQuestion.answer" type="radio" :options="currentQuestion.option" />
          <cube-checker v-if="currentQuestion.type==1" v-model="currentQuestion.answer" :options="currentQuestion.option" :min="1" :max="currentQuestion.limit || currentQuestion.choose" />
        </div>
      </div>
      <div :class="['footer', {'btn-center': !previousBtnDisplay}]">
        <button v-show="previousBtnDisplay" class="default previous" @click.stop="previousQuestion"></button>
        <button :class="['default', 'next', {'active': !nextBtnDisabled}]" @click.prevent="nextQuestion">{{nextBtnText}}</button>
      </div>
    </div>
    <div v-if="!questionnaire.length&&errorPageShow" class="network-error">
      <img class="network-img" src="/images/evaluation-error-loading.png" alt="">
      <p class="error-text">页面加载失败，请联系客服！</p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { wechatShareEvaluationPage } from "@/mixins/wechatShare.js";
import questionnaireIdMap from "@/assets/json/evaluation/questionnaireId.json";
import { differMomentMonth } from "@/utils/filter.js";
import { isEmpty, toString, cloneDeep, isArray } from "lodash";
import moment from "moment";

const CURRENT_QUESTION_INDEX = "zibQuestionnaireCurrentIndex";

export default {
  mixins: [wechatShareEvaluationPage],
  data() {
    return {
      questionnaire: [],
      checkboxAnswer: [],
      currentIndex: 0,
      nextPage: false,
      nextBtnDisabled: true,
      answerList: {},
      kidSex: null,
      errorPageShow: false
    };
  },
  watch: {
    currentIndex: {
      deep: true,
      handler: function(index) {
        if (this.questionnaire.length) {
          let answer = this.questionnaire[index].answer;
          if (this.questionnaire[index].type == 1) {
            this.$set(this.questionnaire[index], answer, answer ? answer : "");
          } else {
            this.$set(this.questionnaire[index], answer, answer ? answer : []);
          }
          if (!!toString(this.questionnaire[index].answer)) {
            this.nextBtnDisabled = false;
          } else {
            this.nextBtnDisabled = true;
          }
        }
        sessionStorage.setItem(CURRENT_QUESTION_INDEX, this.currentIndex);
      }
    },
    kidInfo: {
      immediate: true,
      handler: function(val) {
        if (Object.keys(val).length) {
          let month = differMomentMonth(moment(), moment(+val.birthday));
          this.kidSex = val.sex;
          let outOfRange = true;
          questionnaireIdMap.map(item => {
            if (month >= item.min && month < item.max) {
              this.loadData(item.value);
              outOfRange = false;
            }
          });
          if (outOfRange) {
            if (month >= 144) {
              this.loadData("1112a");
            }
            if (month <= 0) {
              this.loadData("03m");
            }

            outOfRange = false;
          }
          outOfRange && (this.errorPageShow = true);
        } else {
          this.errorPageShow = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      kidInfo: "auth/kidInfo",
      uid: "auth/uid"
    }),
    answers() {
      let arr = [];
      this.questionnaire.map(item => {
        let obj = {};
        if (item.isUserLabel) {
          obj.isUserLabel = item.isUserLabel;
        }
        obj.questionId = item.id;
        obj.answer = item.answer;
        arr.push(obj);
      });
      return arr;
    },
    nextBtnText() {
      return this.currentIndex == this.questionnaire.length - 1
        ? "查看评测报告"
        : "下一题";
    },
    currentQuestion() {
      let questionList = this.questionnaire[this.currentIndex];
      if (!isEmpty(questionList)) {
        questionList.title = questionList.question;
        if (questionList.type == 1) {
          let index = questionList.question.indexOf("（");
          if (index > -1) {
            questionList.title = questionList.question.substring(0, index);
            questionList.multiSelect = questionList.question.substring(
              index,
              questionList.question.length
            );
          }
        }
        return questionList;
      }
    },
    previousBtnDisplay() {
      return (
        this.currentIndex != 0 &&
        this.currentIndex !== this.questionnaire.length - 1
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.fullPath === "/") {
        vm.currentIndex = 0;
        localStorage.setItem(CURRENT_QUESTION_INDEX, vm.currentIndex);
      }
    });
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoadingShow"
    }),
    loadData(questionNum) {
      // this.setLoading({show: true})
      this.$api
        .qms_v1_questionnaire_id_get({
          path: {
            id: questionNum
          }
        })
        .then(res => {
          // this.setLoading({show: false})
          if (!res) {
            this.errorPageShow = true;
            return;
          }
          let { id, code, name } = res.questionnaire;
          this.answerList = {
            uid: this.uid,
            questionnaire: {
              id,
              code,
              name
            }
          };
          this.questionnaire = res.questionnaire.question;
          this.questionnaire.map(item => {
            if (item.type == 1) {
              item.answer = [];
            } else {
              item.answer = "";
            }
            item.option.map(ele => {
              ele.label = ele.text;
            });
          });
        })
        .catch(error => {
          // this.setLoading({show: false})
          this.errorPageShow = true;
        });
    },
    nextQuestion() {
      let flag = false;
      if (this.questionnaire[this.currentIndex].type == 1) {
        if (
          this.currentQuestion.choose &&
          this.questionnaire[this.currentIndex].answer.length <
            this.currentQuestion.choose
        ) {
          flag = true;
        } else if (
          this.currentQuestion.limit &&
          !this.questionnaire[this.currentIndex].answer.length
        ) {
          flag = true;
        }
      } else if (!toString(this.questionnaire[this.currentIndex].answer)) {
        flag = true;
      }
      if (flag) {
        this.$createToast({
          txt: "请选择答案",
          type: "txt",
          time: 700
        }).show();
        return;
      }
      if (this.currentIndex < this.questionnaire.length - 1) {
        this.currentIndex++;
        return;
      }
      this.nextPage = true;
      let answers = cloneDeep(this.answers);
      answers.map(item => {
        if (isArray(item.answer)) {
          let str = "";
          item.answer.map(item1 => {
            str += item1 + ",";
          });
          item.answer = str.substring(0, str.length - 1);
        }
      });
      this.answerList.answers = answers;
      this.setLoading({ show: true, text: "数据提交中" });
      this.$api
        .qms_v1_answer_post({
          data: {
            ...this.answerList
          }
        })
        .then(res => {
          this.setLoading({ show: false });
          if (!res) {
            this.errorPageShow = true;
            return;
          }
          if (!isEmpty(res)) {
            this.$store.commit("evaluation/analysisReport", res);
            this.$router.push("/evaluation/analysis");
          }
        });
    },
    previousQuestion() {
      this.currentIndex--;
    },
    selectQuestion() {
      if (toString(this.currentQuestion.answer)) {
        if (
          this.currentQuestion.type == 1 &&
          this.currentQuestion.choose &&
          this.currentQuestion.answer.length < this.currentQuestion.choose
        ) {
          this.nextBtnDisabled = true;
          return;
        }
        this.nextBtnDisabled = false;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.currentIndex > 0 &&
      this.currentIndex < this.questionnaire.length &&
      !this.nextPage
    ) {
      this.currentIndex--;
      if (!!toString(this.currentQuestion.answer)) {
        this.nextBtnDisabled = false;
      }
      next(false);
    } else {
      next();
    }
  }
};
</script>
<style scoped>
.questionnaire {
  width: 100%;
  height: 100vh;
}
.network-error {
  height: 100%;
  padding-top: 172px;
  text-align: center;
}
.network-error .network-img {
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
}
.network-error .error-text {
  color: #707070;
  font-size: 14px;
}
.container {
  height: 100%;
  padding: 48px 20px 32px;
  background-image: url("/images/ques-star-boy.png");
  background-repeat: no-repeat;
  background-size: 100% 98px;
  background-position: 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.container.girl {
  background-image: url("/images/ques-star-girl.png");
}
.container.boy {
  background-image: url("/images/ques-star-boy.png");
}

.top {
  padding: 20px 16px 35px;
  border-radius: 10px;
  width: 336px;
  height: 136px;
  margin-bottom: 40px;
}
.top.girl {
  box-shadow: 0px 3px 6px rgba(255, 120, 157, 0.1);
  background: url("/images/ques-title-girl.png");
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top.boy {
  background: url("/images/ques-title-boy.png");
  box-shadow: 0px 3px 6px rgba(57, 176, 255, 0.1);
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top .num {
  font-size: 16px;
  color: #6a92a4;
  font-weight: bold;
  margin-bottom: 12px;
}
.top .num .current-num {
  font-size: 22px;
}
.current-num.boy {
  color: #39b0ff;
}
.current-num.girl {
  color: #ff789d;
}
.top .title {
  font-size: 16px;
  color: #244352;
  line-height: 19px;
  font-weight: bold;
}
.boy .title .sub-title {
  color: #39b0ff;
  font-weight: bold;
}
.girl .title .sub-title {
  color: #ff789d;
  font-weight: bold;
}
.main >>> .cube-checker .cube-checker-item {
  padding: 10px 20px;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  box-sizing: content-box;
  border-radius: 30px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  background-color: #f7f8fa;
  margin-right: 18px;
  margin-bottom: 24px;
}
.main >>> .cube-checker-item.cube-checker-item_active {
  background: #2cd5b1;
  color: #fff;
}
.main >>> .cube-checker-item:nth-last-of-type(1) {
  margin-right: 0;
}
.main >>> .cube-checker-item_active::after {
  border: none;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.footer.btn-center {
  justify-content: center;
}

.footer .default {
  outline: none;
  height: 56px;
  line-height: 56px;
  border-radius: 30px;
  background: #ffffff;
  color: #fff;
  font-size: 16px;
  position: relative;
}

.footer .active {
  background: #469dff;
  color: #fff;
  box-shadow: 0px 2px 12px rgba(70, 157, 255, 0.6);
}

.footer .previous {
  width: 88px;
  background: url("/images/question-arrow.png") no-repeat;
  background-size: 11px 17px;
  background-position: 50% 50%;
  background-color: #469dff;
  box-shadow: 0px 2px 12px rgba(70, 157, 255, 0.6);
}

.footer .next {
  width: 200px;
  background: #b4babc;
}

.btn-center .next,
.btn-center .active {
  width: 254px;
}

.footer .next.active {
  background: #469dff;
  box-shadow: 0px 2px 12px rgba(70, 157, 255, 0.6);
}
</style>

